import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useStripe } from '@stripe/react-stripe-js';
import { toggleNoti, toggleError } from 'config/slice/message'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import PreviewForm_v2 from 'components/common/PreviewForm_v2';
import { TEXT_FORM_STEPS_TITLE } from 'config/const/text';
import { useFormSubmitMutation, useGetServiceListMutation } from 'config/api/waV1_user';
import { isEmpty, toInteger, toString } from 'lodash';
import { resp_services } from 'config/const/global';
import './index.css'
import { useTranslation } from 'react-i18next';
import { EN, KEY_ERROR_FORM_FILL_FORM, KEY_ERROR_FORM_SUBMIT_FAILED, KEY_FORM_TITLE_1, KEY_FORM_TITLE_2, KEY_FORM_TITLE_3, KEY_FORM_TITLE_4, KEY_FORM_TITLE_5, KEY_FORM_TITLE_6, KEY_LABEL_FORM_ADDRESS, KEY_LABEL_FORM_BOARD_COM_REG_ADDR, KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM, KEY_LABEL_FORM_BOARD_COM_REG_C, KEY_LABEL_FORM_BOARD_COM_REG_NUM, KEY_LABEL_FORM_BOARD_HOLADING, KEY_LABEL_FORM_BOARD_INDENTITY, KEY_LABEL_FORM_BOARD_INDENTITY_COMPANY, KEY_LABEL_FORM_BOARD_INDENTITY_DIRECTOR, KEY_LABEL_FORM_BOARD_INDENTITY_PERSONAL, KEY_LABEL_FORM_BOARD_INDENTITY_SHAREHOLDER, KEY_LABEL_FORM_BOARD_NO_AFTER, KEY_LABEL_FORM_BOARD_NO_BEFORE, KEY_LABEL_FORM_BOARD_NUM, KEY_LABEL_FORM_BOARD_NUM_NEW, KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER, KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE, KEY_LABEL_FORM_BOARD_SH_CN_NAME, KEY_LABEL_FORM_BOARD_SH_EMAIL, KEY_LABEL_FORM_BOARD_SH_EN_NAME, KEY_LABEL_FORM_BOARD_SH_IC_AFTER, KEY_LABEL_FORM_BOARD_SH_IC_BEFORE, KEY_LABEL_FORM_BOARD_SH_ID_AFTER, KEY_LABEL_FORM_BOARD_SH_ID_BEFORE, KEY_LABEL_FORM_BOARD_SH_PHONE, KEY_LABEL_FORM_BUS_NATURE, KEY_LABEL_FORM_BUS_REGION, KEY_LABEL_FORM_COM_ADDR, KEY_LABEL_FORM_COM_ADDR_REG, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_NO, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_YES, KEY_LABEL_FORM_COM_CN_NAME, KEY_LABEL_FORM_COM_EN_NAME, KEY_LABEL_FORM_CONTACT_SLOT, KEY_LABEL_FORM_CONTACT_SLOT_23, KEY_LABEL_FORM_CONTACT_SLOT_35, KEY_LABEL_FORM_CONTACT_SLOT_912, KEY_LABEL_FORM_CONTACT_WAY, KEY_LABEL_FORM_CONTACT_WAY_EMAIL, KEY_LABEL_FORM_CONTACT_WAY_PHONE, KEY_LABEL_FORM_CONTACT_WAY_WECHAT, KEY_LABEL_FORM_CONTACT_WAY_WECHAT_NO, KEY_LABEL_FORM_CONTACT_WAY_WTS, KEY_LABEL_FORM_EMAIL, KEY_LABEL_FORM_IS_NUM, KEY_LABEL_FORM_NAME, KEY_LABEL_FORM_NEXT, KEY_LABEL_FORM_PHONE, KEY_LABEL_FORM_PRESET_SHARES, KEY_LABEL_FORM_PRESET_SHARES_NO, KEY_LABEL_FORM_PRESET_SHARES_YES, KEY_LABEL_FORM_PREVIEW, KEY_LABEL_FORM_PREVIOUS, KEY_LABEL_FORM_SUBMIT, KEY_LABEL_FORM_TITLE, KEY_LABEL_FORM_TITLE_FEMALE, KEY_LABEL_FORM_TITLE_MALE, KEY_LABEL_FORM_VAL, KEY_LABEL_FORM_VALUE_ADDED, KEY_LABEL_FORM_VALUE_ADDED_BA, KEY_LABEL_FORM_VALUE_ADDED_BE, KEY_LABEL_FORM_VALUE_ADDED_CP, KEY_LABEL_FORM_VALUE_ADDED_CP_1, KEY_LABEL_FORM_VALUE_ADDED_CP_2, KEY_LABEL_FORM_VALUE_ADDED_CS, KEY_LABEL_FORM_VALUE_ADDED_CSE, KEY_LABEL_FORM_VALUE_ADDED_CS_1, KEY_LABEL_FORM_VALUE_ADDED_CS_2, KEY_LABEL_FORM_VALUE_ADDED_TM, KEY_LABEL_FORM_VAL_TOTAL, KEY_NOTI_FORM_SUBMIT_SUCC, MODULE_PREVIEW_ROUTER_FORM, ZH, ZH_CN } from 'config/const/locale';


// custom component
const RBox = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down('xl')]: {
        width: '100%'
    },
    [theme.breakpoints.up('xl')]: {
        width: '80%'
    }
}));

const plans_limited = [
    {
        id: 1,
        value: '1',
        label: '套餐A'
    },
    {
        id: 2,
        value: '2',
        label: '套餐B'
    },
    {
        id: 3,
        value: '3',
        label: '套餐C'
    }
]
const plans_unlimited = [
    {
        id: 1,
        value: '4',
        label: '套餐A'
    },
    {
        id: 2,
        value: '5',
        label: '套餐B'
    },
    {
        id: 3,
        value: '6',
        label: '套餐C'
    },
    {
        id: 4,
        value: '7',
        label: '套餐D'
    }
]

const A_SHAREHOLDER = {
    type: '',
    identity: '',
    shareholding: '',
    en_name: '',
    zh_name: '',
    tel: '',
    email: '',
    address: '',
    hkid: '',
    issuing_country: '',
    co_register_office_addr: '',
    co_incorp_no: '',
    business_registration: '',
    formation_country: '',
    // order_shareholder,
}

export default function FormA_v2({
    serveAs
}) {

    const stripe = useStripe()

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)
    const { lng } = useSelector(state => state?.global)

    const dispatch = useDispatch()
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [submit, setSubmit] = React.useState(false);
    // const [plans, setPlans] = React.useState(services.filter(i => i.name.includes(serveAs)).sort((a, b) => a.id - b.id))
    const [plans, setPlans] = React.useState(resp_services?.value?.value.filter(i => i.name.includes(serveAs)).sort((a, b) => a.id - b.id))
    const [shareholders, setShareholders] = React.useState([
        A_SHAREHOLDER
    ])
    const [userIpt, setUserIpt] = React.useState({
        name: '',
        title: t(KEY_LABEL_FORM_TITLE_MALE),
        phone: '',
        email: '',
        address: '',
        contact_way: t(KEY_LABEL_FORM_CONTACT_WAY_WTS),
        wechat_no: '',
        contact_timeslot: t(KEY_LABEL_FORM_CONTACT_SLOT_912),
        page: plans[0]?.id,
        company_name_en: '',
        company_name_zh: '',
        company_address: '',
        is_use_wa_addr: '1',
        company_reg_address: '',
        is_std_share_value: '1',
        no_shares_issued: '1',
        shares_par_value: '1',
        shares_total_value: '1',
        business_nature: '',
        geo_location_bus_nature: '',
        sMemberNum: '1',
        shareholders: shareholders,
        eService: []
    })

    const [formSubmit] = useFormSubmitMutation()
    const [getSListFn] = useGetServiceListMutation()

    const steps = [
        t(KEY_FORM_TITLE_1),
        t(KEY_FORM_TITLE_2),
        t(KEY_FORM_TITLE_3),
        t(KEY_FORM_TITLE_4),
        t(KEY_FORM_TITLE_5),
        t(KEY_FORM_TITLE_6),
    ];

    const errors_tips = {
        name: t(KEY_LABEL_FORM_NAME),
        title: t(KEY_LABEL_FORM_TITLE),
        phone: t(KEY_LABEL_FORM_PHONE),
        email: t(KEY_LABEL_FORM_EMAIL),
        address: t(KEY_LABEL_FORM_ADDRESS),
        contact_way: t(KEY_LABEL_FORM_CONTACT_WAY),
        wechat_no: t(KEY_LABEL_FORM_CONTACT_WAY_WECHAT_NO),
        contact_timeslot: t(KEY_LABEL_FORM_CONTACT_SLOT),
        company_name_en: t(KEY_LABEL_FORM_COM_EN_NAME),
        company_name_zh: t(KEY_LABEL_FORM_COM_CN_NAME),
        company_address: t(KEY_LABEL_FORM_COM_ADDR),
        is_use_wa_addr: t(KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT),
        company_reg_address: '',
        is_std_share_value: t(KEY_LABEL_FORM_PRESET_SHARES),
        no_shares_issued: t(KEY_LABEL_FORM_IS_NUM),
        shares_par_value: t(KEY_LABEL_FORM_VAL),
        shares_total_value: t(KEY_LABEL_FORM_VAL_TOTAL),
        business_nature: t(KEY_LABEL_FORM_BUS_NATURE),
        geo_location_bus_nature: t(KEY_LABEL_FORM_BUS_REGION),
    }

    const isStepOptional = (step) => {
        return step === -1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        if (activeStep == steps.length - 1) {
            if (!checkForm()) return
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.");
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const checkForm = () => {
        let flag = true
        let attr = ''
        Object.keys(userIpt)
            .filter(
                i => {
                    if (i == 'wechat_no') return false
                    if (i == 'company_reg_address') return false
                    if (i == 'eService') return false
                    if (i == 'sMemberNum') return false
                    if (i == 'title') return false
                    if (i == 'contact_timeslot') return false
                    if (i == 'contact_way') return false
                    if (i == 'is_use_wa_addr') return false
                    if (i == 'page') return false
                    if (i == 'is_std_share_value') return false
                    if (i == 'no_shares_issued') return false
                    if (i == 'shares_par_value') return false
                    if (i == 'shares_total_value') return false
                    return true
                }
            )
            .reverse()
            .map(
                i => {
                    if (isEmpty(toString(userIpt[i]))) {
                        attr = i
                        flag = false
                    }
                }
            )
            .filter(
                i => {
                    if (i == 'wechat_no') return false
                    if (i == 'company_reg_address') return false
                    return true
                }
            )
        if (!flag) {
            dispatch(toggleError({
                indicator: true,
                msg: `${t(KEY_ERROR_FORM_FILL_FORM)} - ${errors_tips[attr]}`
            }))
            return false
        }
        return true
    }

    const parseEService = () => {
        return userIpt.eService.map(i => ({ id: toInteger(i), quantity: 1 })) || []
    }

    const handleReset = () => {

        const temp = {
            services: [
                {
                    id: toInteger(userIpt.page),
                    quantity: 1
                },
                ...parseEService()
            ],
            "payment_method": "stripe",
            "user_service": {
                ...userIpt,
                "is_crossborder": 0,
                "contact_way": userIpt.contact_way == t(KEY_LABEL_FORM_CONTACT_WAY_WECHAT) ? userIpt.contact_way + userIpt.wechat_no : userIpt.contact_way,
                "is_use_wa_addr": toInteger(userIpt.is_use_wa_addr),
                "is_std_share_value": toInteger(userIpt.is_std_share_value),
                "no_shares_issued": toInteger(userIpt.no_shares_issued),
                "shares_par_value": toInteger(userIpt.shares_par_value),
                "shares_total_value": toInteger(userIpt.shares_total_value),
                "shareholders": userIpt.shareholders.map(i => ({ ...i, identity: typeof i?.identity == 'object' && i?.identity?.join('、') })),
                "files": [],
            }
        }

        if (!checkForm()) return

        setSubmit(true)
        formSubmit(temp)
            .then(res => {
                if (res.data?.data) {
                    stripe.redirectToCheckout({
                        sessionId: res.data?.data?.invoice?.checkoutSession?.id
                    })
                        .then(({ error }) => {
                            if (error) {
                                dispatch(toggleError({
                                    indicator: true,
                                    msg: t(KEY_ERROR_FORM_SUBMIT_FAILED)
                                }))
                            } else {
                                dispatch(toggleNoti({
                                    indicator: true,
                                    msg: t(KEY_NOTI_FORM_SUBMIT_SUCC)
                                }))
                            }
                        })
                    setActiveStep(0);
                } else {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_FORM_SUBMIT_FAILED)
                    }))
                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_FORM_SUBMIT_FAILED)
                }))
                setSubmit(false)
            })
    };

    const handleArrayValue = (flag, value, array) => {
        if (flag) {
            if (new Array(...array).indexOf(value) !== -1) return array
            else return [...array, value]
        } else {
            return new Array(...array).filter(i => i !== value)
        }
    }

    const saveValue = (propsName, value) => {
        switch (propsName) {
            case 'contact_way':
                if (value !== t(KEY_LABEL_FORM_CONTACT_WAY_WECHAT))
                    setUserIpt(p => ({ ...p, 'wechat_no': '' }))
                break;
            case 'is_use_wa_addr':
                if (value !== '0')
                    setUserIpt(p => ({ ...p, 'company_reg_address': '' }))
                break;
            case 'is_std_share_value':
                if (value !== '0')
                    setUserIpt(p => ({ ...p, 'no_shares_issued': '', 'shares_par_value': '', 'shares_total_value': '' }))
                break;

            default:
                break;
        }
        setUserIpt(p => ({ ...p, [propsName]: value }))
    }

    const addNewShareholder = () => {
        setShareholders(p => [...p, { ...A_SHAREHOLDER }])
    }

    const shareholderLayoutRenderer = React.useCallback(() => shareholders.map(
        (i, index) => (
            <React.Fragment key={index}>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={5} xs={5}>
                    <FormControl>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_BOARD_NO_BEFORE)} {index + 1} {t(KEY_LABEL_FORM_BOARD_NO_AFTER)} </FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={i.type}
                                name="type"
                                onChange={(e) => {
                                    i.type = e.target.value
                                    setUserIpt(p => ({ ...p, shareholders: [...shareholders] }))
                                }}
                            >
                                <FormControlLabel value={t(KEY_LABEL_FORM_BOARD_INDENTITY_PERSONAL)} control={<Radio />} label={t(KEY_LABEL_FORM_BOARD_INDENTITY_PERSONAL)} />
                                <FormControlLabel value={t(KEY_LABEL_FORM_BOARD_INDENTITY_COMPANY)} control={<Radio />} label={t(KEY_LABEL_FORM_BOARD_INDENTITY_COMPANY)} />
                            </RadioGroup>
                        </Box>
                    </FormControl>
                </Grid>
                <Grid item sm={5} xs={5}>
                    <FormControl>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_BOARD_INDENTITY)} </FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={i.identity}
                                name="identity"
                            >
                                <FormControlLabel value={t(KEY_LABEL_FORM_BOARD_INDENTITY_DIRECTOR)} control={<Checkbox checked={i.identity.indexOf(t(KEY_LABEL_FORM_BOARD_INDENTITY_DIRECTOR)) == -1 ? false : true} onChange={(e) => { i.identity = handleArrayValue(e.target.checked, e.target.value, i.identity); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_LABEL_FORM_BOARD_INDENTITY_DIRECTOR)} />
                                <FormControlLabel value={t(KEY_LABEL_FORM_BOARD_INDENTITY_SHAREHOLDER)} control={<Checkbox checked={i.identity.indexOf(t(KEY_LABEL_FORM_BOARD_INDENTITY_SHAREHOLDER)) == -1 ? false : true} onChange={(e) => { i.identity = handleArrayValue(e.target.checked, e.target.value, i.identity); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_LABEL_FORM_BOARD_INDENTITY_SHAREHOLDER)} />
                            </RadioGroup>
                        </Box>
                    </FormControl>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={2} xs={2}>
                    <FormControl>
                        <TextField label={t(KEY_LABEL_FORM_BOARD_HOLADING)} type="text" value={i.shareholding} onChange={(e) => { i.shareholding = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={3} xs={3}>
                    <FormControl>
                        <TextField label={`${t(KEY_LABEL_FORM_BOARD_NO_BEFORE)} ${index + 1} ${t(KEY_LABEL_FORM_BOARD_SH_EN_NAME)}`} value={i.en_name} type="text" onChange={(e) => { i.en_name = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={3} xs={3}>
                    <FormControl>
                        <TextField label={`${t(KEY_LABEL_FORM_BOARD_NO_BEFORE)} ${index + 1} ${t(KEY_LABEL_FORM_BOARD_SH_CN_NAME)}`} type="text" value={i.zh_name} onChange={(e) => { i.zh_name = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={2} xs={2}>
                    <FormControl>
                        <TextField label={t(KEY_LABEL_FORM_BOARD_SH_PHONE)} type="tel" value={i.tel} onChange={(e) => { i.tel = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={3} xs={3}>
                    <FormControl>
                        <TextField label={t(KEY_LABEL_FORM_BOARD_SH_EMAIL)} type="text" value={i.email} onChange={(e) => { i.email = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={7} xs={7}>
                    <FormControl>
                        <TextField label={`${t(KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE)} ${index + 1} ${t(KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER)}`} type="text" value={i.address} onChange={(e) => { i.address = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={2} xs={2}>
                    <FormControl>
                        <TextField label={`${t(KEY_LABEL_FORM_BOARD_SH_ID_BEFORE)} ${index + 1} ${t(KEY_LABEL_FORM_BOARD_SH_ID_AFTER)}`} type="text" value={i.hkid} onChange={(e) => { i.hkid = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={2} xs={2}>
                    <FormControl>
                        <TextField label={`${t(KEY_LABEL_FORM_BOARD_SH_IC_BEFORE)} ${index + 1} ${t(KEY_LABEL_FORM_BOARD_SH_IC_AFTER)}`} type="text" value={i.issuing_country} onChange={(e) => { i.issuing_country = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                {
                    i.type == t(KEY_LABEL_FORM_BOARD_INDENTITY_COMPANY)
                        ? (
                            <>
                                <Grid item sm={6} xs={6}>
                                    <FormControl>
                                        <TextField label={t(KEY_LABEL_FORM_BOARD_COM_REG_ADDR)} type="text" value={i.co_register_office_addr} onChange={(e) => { i.co_register_office_addr = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={1} xs={1}></Grid>
                                <Grid item sm={1} xs={1}></Grid>
                                <Grid item sm={4} xs={4}>
                                    <FormControl>
                                        <TextField label={t(KEY_LABEL_FORM_BOARD_COM_REG_NUM)} type="text" value={i.co_incorp_no} onChange={(e) => { i.co_incorp_no = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={4} xs={4}>
                                    <FormControl>
                                        <TextField label={t(KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM)} type="text" value={i.business_registration} onChange={(e) => { i.business_registration = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={2} xs={2}>
                                    <FormControl>
                                        <TextField label={t(KEY_LABEL_FORM_BOARD_COM_REG_C)} type="text" value={i.formation_country} onChange={(e) => { i.formation_country = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                                    </FormControl>
                                </Grid>
                            </>
                        )
                        : false
                }
                <Grid item sm={12} xs={12}>&nbsp;</Grid>
            </React.Fragment>
        )
    ), [shareholders])

    React.useEffect(() => {

        const AA_SHAREHOLDER = {
            type: '',
            identity: '',
            shareholding: '',
            en_name: '',
            zh_name: '',
            tel: '',
            email: '',
            address: '',
            hkid: '',
            issuing_country: '',
            co_register_office_addr: '',
            co_incorp_no: '',
            business_registration: '',
            formation_country: '',
            source_of_fund: ''
            // order_shareholder,
        }

        switch (userIpt.sMemberNum) {
            case '1':
                if (shareholders.lenngth >= 2) return setShareholders(p => p.slice(0, 1))
                return setShareholders(p => p)
            case '2':
                if (shareholders.lenngth >= 3) return setShareholders(p => p.slice(0, 2))
                return setShareholders(p => [...p, ...new Array(2 - p.length).fill({ ...AA_SHAREHOLDER })])
            case '3':
                if (shareholders.lenngth >= 4) return setShareholders(p => p.slice(0, 3))
                return setShareholders(p => [...p, ...new Array(3 - p.length).fill({ ...AA_SHAREHOLDER })])
            case '4':
                if (shareholders.lenngth >= 5) return setShareholders(p => p.slice(0, 4))
                return setShareholders(p => [...p, ...new Array(4 - p.length).fill({ ...AA_SHAREHOLDER })])
            case '5':
                if (shareholders.lenngth >= 6) return setShareholders(p => p.slice(0, 5))
                return setShareholders(p => [...p, ...new Array(5 - p.length).fill({ ...AA_SHAREHOLDER })])

            default:
                if (shareholders.lenngth >= 2) return setShareholders(p => p.slice(0, 1))
                return setShareholders(p => p)
        }
        // switch (userIpt.sMemberNum) {
        //     case '1':
        //         if(shareholders.lenngth >=2) return setShareholders(p => p.slice(0, 1))
        //         return setShareholders(p => p)
        //     case '2':
        //         if(shareholders.lenngth >=3) return setShareholders(p => p.slice(0, 2))
        //         return setShareholders([{ ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }])
        //     case '3':
        //         return setShareholders([{ ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }])
        //     case '4':
        //         return setShareholders([{ ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }])
        //     case '5':
        //         return setShareholders([{ ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }, { ...A_SHAREHOLDER }])

        //     default:
        //         return setShareholders([{ ...A_SHAREHOLDER }])
        // }
    }, [userIpt.sMemberNum])

    const formSectionRenderer = React.useCallback((step) => {
        switch (step) {
            case 0:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}

                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            {/* offset-1 */}
                            <Grid item sm={1} xs={1} ></Grid>
                            <Grid item sm={2} xs={2} >
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_NAME)} type="text" value={userIpt.name} onChange={(e) => saveValue('name', e.target.value)} />
                                </FormControl>
                            </Grid>

                            <Grid item sm={3} xs={3}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'center ', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_TITLE)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue={t(KEY_LABEL_FORM_TITLE_MALE)}
                                            value={userIpt.title}
                                            name="title"
                                            onChange={(e) => saveValue('title', e.target.value)}
                                        >
                                            <FormControlLabel value={t(KEY_LABEL_FORM_TITLE_MALE)} control={<Radio />} label={t(KEY_LABEL_FORM_TITLE_MALE)} />
                                            <FormControlLabel value={t(KEY_LABEL_FORM_TITLE_FEMALE)} control={<Radio />} label={t(KEY_LABEL_FORM_TITLE_FEMALE)} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>

                            <Grid item sm={2} xs={2}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_PHONE)} type="text" value={userIpt.phone} onChange={(e) => saveValue('phone', e.target.value)} />
                                </FormControl>
                            </Grid>

                            <Grid item sm={3} xs={3}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_EMAIL)} type="text" value={userIpt.email} onChange={(e) => saveValue('email', e.target.value)} />
                                </FormControl>
                            </Grid>

                            {/* offset-2 */}
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_ADDRESS)} type="text" value={userIpt.address} onChange={(e) => saveValue('address', e.target.value)} />
                                </FormControl>
                            </Grid>

                            {/* offset-2 */}
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_CONTACT_WAY)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue={t(KEY_LABEL_FORM_CONTACT_WAY_WTS)}
                                            value={userIpt.contact_way}
                                            onChange={(e) => saveValue('contact_way', e.target.value)}
                                        >
                                            <FormControlLabel value={t(KEY_LABEL_FORM_CONTACT_WAY_WTS)} control={<Radio />} label={t(KEY_LABEL_FORM_CONTACT_WAY_WTS)} />
                                            <FormControlLabel value={t(KEY_LABEL_FORM_CONTACT_WAY_PHONE)} control={<Radio />} label={t(KEY_LABEL_FORM_CONTACT_WAY_PHONE)} />
                                            <FormControlLabel value={t(KEY_LABEL_FORM_CONTACT_WAY_EMAIL)} control={<Radio />} label={t(KEY_LABEL_FORM_CONTACT_WAY_EMAIL)} />
                                            <FormControlLabel value={t(KEY_LABEL_FORM_CONTACT_WAY_WECHAT)} control={<Radio />} label={t(KEY_LABEL_FORM_CONTACT_WAY_WECHAT)} />
                                        </RadioGroup>
                                        {
                                            userIpt.contact_way === t(KEY_LABEL_FORM_CONTACT_WAY_WECHAT) ? (
                                                <TextField label={t(KEY_LABEL_FORM_CONTACT_WAY_WECHAT_NO)} type="text" value={userIpt.wechat_no} sx={{ flex: '1' }} onChange={(e) => saveValue('wechat_no', e.target.value)} />
                                            ) : false
                                        }

                                    </Box>
                                </FormControl>
                            </Grid>

                            {/* offset-4 */}
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={11} xs={11}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_CONTACT_SLOT)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue={t(KEY_LABEL_FORM_CONTACT_SLOT_912)}
                                            value={userIpt.contact_timeslot}
                                            name="contact_timeslot"
                                            onChange={(e) => saveValue('contact_timeslot', e.target.value)}
                                        >
                                            <FormControlLabel value={t(KEY_LABEL_FORM_CONTACT_SLOT_912)} control={<Radio />} label={t(KEY_LABEL_FORM_CONTACT_SLOT_912)} />
                                            <FormControlLabel value={t(KEY_LABEL_FORM_CONTACT_SLOT_23)} control={<Radio />} label={t(KEY_LABEL_FORM_CONTACT_SLOT_23)} />
                                            <FormControlLabel value={t(KEY_LABEL_FORM_CONTACT_SLOT_35)} control={<Radio />} label={t(KEY_LABEL_FORM_CONTACT_SLOT_35)} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </RBox>
                );

            case 1:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={1}></Grid>
                            <Grid item sm={11}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <Grid container spacing={2}>
                                            <Grid item sm={12}>
                                                <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{steps[1]} </FormLabel>
                                            </Grid>
                                            <Grid item sm={12}>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    value={userIpt.page}
                                                    name="page"
                                                    onChange={(e) => saveValue('page', e.target.value)}
                                                >
                                                    <Grid container spacing={2}>
                                                        {
                                                            plans.map(
                                                                i => (
                                                                    <Grid item sm={12} key={i.id}>
                                                                        <FormControlLabel value={i.id} control={<Radio />} label={i.locale_name + " -- " + "HKD" + i.current_price} />
                                                                        <br />
                                                                        <Typography variant='p'>
                                                                            {
                                                                                lng === ZH
                                                                                    ? i?.content_tc
                                                                                    : lng === ZH_CN
                                                                                        ? i?.content_cn
                                                                                        : lng === EN
                                                                                            ? i?.content_en
                                                                                            : i?.content
                                                                            }
                                                                        </Typography>
                                                                    </Grid>
                                                                )
                                                            )
                                                        }
                                                    </Grid>
                                                    {/* <FormControlLabel value="成立香港有限公司" control={<Radio />} label="成立香港有限公司" />
                                            <FormControlLabel value="購買香港現成有限公司" control={<Radio />} label="購買香港現成有限公司" />
                                            <FormControlLabel value="成立香港無限有限公司" control={<Radio />} label="成立香港無限有限公司" /> */}
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </RBox>
                )

            case 2:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={1} xs={1} ></Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_EN_NAME)} type="text" value={userIpt.company_name_en} onChange={(e) => saveValue('company_name_en', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_CN_NAME)} type="text" value={userIpt.company_name_zh} onChange={(e) => saveValue('company_name_zh', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_ADDR)} type="text" value={userIpt.company_address} onChange={(e) => saveValue('company_address', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={11} xs={11}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="1"
                                            value={userIpt.is_use_wa_addr}
                                            name="is_use_wa_addr"
                                            onChange={(e) => saveValue('is_use_wa_addr', e.target.value)}
                                        >
                                            <FormControlLabel value="1" control={<Radio />} label={t(KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_YES)} />
                                            <FormControlLabel value="0" control={<Radio />} label={t(KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_NO)} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            {
                                userIpt.is_use_wa_addr == '0'
                                    ? (
                                        <>
                                            <Grid item sm={1} xs={1}></Grid>
                                            <Grid item sm={10} xs={10}>
                                                <FormControl>
                                                    <TextField label={t(KEY_LABEL_FORM_COM_ADDR_REG)} type="text" value={userIpt.company_reg_address} onChange={(e) => saveValue('company_reg_address', e.target.value)} />
                                                </FormControl>
                                            </Grid>
                                        </>
                                    )
                                    : false
                            }
                        </Grid>
                    </RBox>
                )

            case 3:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5.5} xs={5.5}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_PRESET_SHARES)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="1"
                                            value={userIpt.is_std_share_value}
                                            name="is_std_share_value"
                                            onChange={(e) => saveValue('is_std_share_value', e.target.value)}
                                        >
                                            <FormControlLabel value="1" control={<Radio />} label={t(KEY_LABEL_FORM_PRESET_SHARES_YES)} />
                                            <FormControlLabel value="0" control={<Radio />} label={t(KEY_LABEL_FORM_PRESET_SHARES_NO)} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>

                            {
                                userIpt.is_std_share_value == '0'
                                    ? (
                                        <>
                                            <Grid item sm={1.5} xs={1.5}>
                                                <FormControl>
                                                    <TextField label={t(KEY_LABEL_FORM_IS_NUM)} type="text" value={userIpt.no_shares_issued} onChange={(e) => saveValue('no_shares_issued', e.target.value)} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item sm={2} xs={2}>
                                                <FormControl>
                                                    <TextField label={t(KEY_LABEL_FORM_VAL)} type="text" value={userIpt.shares_par_value} onChange={(e) => saveValue('shares_par_value', e.target.value)} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item sm={1.5} xs={1.5}>
                                                <FormControl>
                                                    <TextField label={t(KEY_LABEL_FORM_VAL_TOTAL)} type="text" value={userIpt.shares_total_value} onChange={(e) => saveValue('shares_total_value', e.target.value)} />
                                                </FormControl>
                                            </Grid>

                                        </>
                                    )
                                    : (
                                        <>
                                            <Grid item sm={4} xs={4}></Grid>
                                            <Grid item sm={1} xs={1}></Grid>
                                        </>
                                    )
                            }


                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5.25} xs={5.25}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_BUS_NATURE)} type="text" value={userIpt.business_nature} onChange={(e) => saveValue('business_nature', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={5.25} xs={5.25}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_BUS_REGION)} type="text" value={userIpt.geo_location_bus_nature} onChange={(e) => saveValue('geo_location_bus_nature', e.target.value)} />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </RBox>
                )

            case 4:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={11} xs={11}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_BOARD_NUM)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="1"
                                            value={shareholders.length}
                                            name="sMemberNum"
                                            onChange={(e) => {
                                                saveValue('sMemberNum', e.target.value)
                                                setShareholders(p => {
                                                    setUserIpt(pp => ({ ...pp, shareholders: p.slice(0, toInteger(e.target.value)) }))
                                                    return p.slice(0, toInteger(e.target.value))
                                                })
                                            }}
                                        >
                                            <FormControlLabel value="1" control={<Radio />} label="1" />
                                            <FormControlLabel value="2" control={<Radio />} label="2" />
                                            <FormControlLabel value="3" control={<Radio />} label="3" />
                                            <FormControlLabel value="4" control={<Radio />} label="4" />
                                            <FormControlLabel value="5" control={<Radio />} label="5" />
                                            <FormControlLabel value="5" control={<Button children={t(KEY_LABEL_FORM_BOARD_NUM_NEW)} onClick={addNewShareholder} />} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            {
                                // memberNoRenderer(userIpt.sMemberNum)
                                shareholderLayoutRenderer()
                            }
                        </Grid>
                    </RBox>
                )

            case 5:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_VALUE_ADDED)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            value={userIpt.eService}
                                            name="eService"
                                        >
                                            {/* {
                                                services.filter(i => i.name.includes('value_added_service') && !i.name.includes('serviced_office'))
                                                    .map(i => <FormControlLabel value={i.id} control={<Checkbox checked={userIpt.eService.indexOf(i.id) == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={i.locale_name} />)
                                            } */}
                                            <FormControlLabel value="16" control={<Checkbox checked={userIpt.eService.indexOf('16') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_BE)} />
                                            <FormControlLabel value="12" control={<Checkbox checked={userIpt.eService.indexOf('12') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_CP_1)} />
                                            <FormControlLabel value="13" control={<Checkbox checked={userIpt.eService.indexOf('13') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_CP_2)} />
                                            <FormControlLabel value="15" control={<Checkbox checked={userIpt.eService.indexOf('15') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_CS_1)} />
                                            <FormControlLabel value="14" control={<Checkbox checked={userIpt.eService.indexOf('14') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_CS_2)} />
                                            <FormControlLabel value="17" control={<Checkbox checked={userIpt.eService.indexOf('17') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_BA)} />
                                            <FormControlLabel value="18" control={<Checkbox checked={userIpt.eService.indexOf('18') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_TM)} />
                                            {/* <FormControlLabel value="15" control={<Checkbox checked={userIpt.eService.indexOf('15') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_CSE)} /> */}
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </RBox>
                )

            default:
                break;
        }
    }, [userIpt, plans, shareholders])

    React.useEffect(() => {
        const temp = resp_services?.value?.value.filter(i => i.name.includes(serveAs)).sort((a, b) => a.id - b.id)
        setPlans(temp)
        setUserIpt(p => ({ ...p, page: temp[0]?.id }))
        setActiveStep(0)
    }, [serveAs])

    React.useEffect(() => {
        getSListFn()
            .then(res => {
                if (res.data?.data) {
                    setPlans(
                        res.data?.data?.services?.data.filter(i => i.name.includes(serveAs)).sort((a, b) => a.id - b.id)
                    )
                }
            })
    }, [serveAs, lng])

    const formPreviewRenderer = React.useMemo(() => <PreviewForm_v2 {...userIpt} />, [userIpt])

    return (
        <Box sx={{ width: '100%' }}>
            <Stepper className='stepper-hor' activeStep={activeStep} size='sm' sx={{
                mb: 6,

            }} >
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepOptional(index)) {
                        labelProps.optional = (
                            <Typography variant="caption">可選</Typography>
                        );
                    }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps} >
                                <Typography variant='span' sx={{ fontSize: 16 }}>{label}</Typography>
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>

            {activeStep === steps.length ? (
                <React.Fragment>
                    {/* <Typography sx={{ mt: 2, mb: 1 }}>
                        已遞交
                    </Typography> */}
                    {formPreviewRenderer}
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button
                            color="inherit"
                            disabled={activeStep === 0}
                            variant='contained'
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            {t(KEY_LABEL_FORM_PREVIOUS)}
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button variant='contained' onClick={submit ? () => { } : handleReset}>{t(KEY_LABEL_FORM_SUBMIT)}</Button>
                    </Box>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Typography variant='h5' sx={{ mt: 2, mb: 2, ml: 1, pt: 1, pb: 1, border: '1px solid #aaa', borderLeftWidth: 0, borderRightWidth: 0 }}>{steps[activeStep]}</Typography>
                    {formSectionRenderer(activeStep)}
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button
                            color="inherit"
                            variant='contained'
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            {t(KEY_LABEL_FORM_PREVIOUS)}
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        {/* {isStepOptional(activeStep) && (
                            <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                                Skip
                            </Button>
                        )} */}

                        <Button variant='contained' onClick={handleNext}>
                            {activeStep === steps.length - 1 ? t(KEY_LABEL_FORM_PREVIEW) : t(KEY_LABEL_FORM_NEXT)}
                        </Button>
                    </Box>
                </React.Fragment>
            )}
        </Box>
    );
}
